import { ActionTypes } from "../constants/action-types";
const initialState = {
    
};


export function descriptionReducer(state = initialState, { type, payload }) {
    switch (type) {
        case ActionTypes.SET_DESCRIPTION_DATA:
            return { ...state, globalDescription: payload };
        case ActionTypes.SET_IMPORTANT_DATE_DESCRIPTION:
            return { ...state, importantDateDescription: payload ?? [] };
        default:
            return state;
    }
}